import paymentTerms from '../api/paymentTerms'

export default {
    state: {
        terms: [],
    },
    namespaced: true,
    mutations: {
        async getPaymentTerms(state, terms) {
            state.terms = terms
        },
    },
    actions: {
        async getPaymentTerms({dispatch, commit}, data) {
            commit('getPaymentTerms', await paymentTerms.getPaymentTerms());
        },
    },
    getters: {
        terms: state => state.terms
    },
}